import { render, staticRenderFns } from "./activities-filter.vue?vue&type=template&id=2842e5bc&"
import script from "./activities-filter.vue?vue&type=script&lang=js&"
export * from "./activities-filter.vue?vue&type=script&lang=js&"
import style0 from "./activities-filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports